import { emptyObj } from '@beef/utils';
import { selectHeader } from "../store/common";
export var selectHeaderDataForMetric = function selectHeaderDataForMetric(state) {
  return state ? selectHeader(state) : emptyObj;
};